import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const ProcessingProgress = ({ show, progress }) => {
  const intl = useIntl();

  if (!show || progress.total <= 1) {
    return null;
  }

  return (
    intl.formatMessage({ defaultMessage: `{nbsp}({done} of {total})` }, {
      done: progress.done,
      total: progress.total,
      nbsp: ' ',
    })
  );
};

ProcessingProgress.propTypes = {
  show: PropTypes.bool,
  progress: PropTypes.object.isRequired,
};

ProcessingProgress.defaultProps = {
  show: true,
};

export default ProcessingProgress;
